import {compose} from 'recompose';

import redux from './redux';

export default compose(
  redux
);
